import { render, staticRenderFns } from "./filingManagementPersonnel.vue?vue&type=template&id=0cf07508&scoped=true"
import script from "./filingManagementPersonnel.vue?vue&type=script&lang=js"
export * from "./filingManagementPersonnel.vue?vue&type=script&lang=js"
import style0 from "./filingManagementPersonnel.vue?vue&type=style&index=0&id=0cf07508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf07508",
  null
  
)

export default component.exports